<style>
#AttributesElementEditing .v-datatable .v-list__tile {
  height: auto !important;
}
#AttributesElementEditing {
  z-index: 300 !important;
}
#AttributesElementEditing .v-datatable .v--modal-box.v--modal {
  min-height: 350px !important;
  min-width: 750px !important;
}
#AttributesElementEditing table.v-table.v-datatable tbody tr {
  max-height: 45px;
  height: 45px;
}
#AttributesElementEditing table.v-table.v-datatable tbody td,
#AttributesElementEditing-scroll .v-datatable div.v-select__selections > div,
#AttributesElementEditing-scroll .v-datatable label,
#AttributesElementEditing-scroll .v-datatable input[type="datetime-local"],
#AttributesElementEditing-scroll .v-datatable input[type="text"] {
  height: auto;
  font-size: 12px;
}
#AttributesElementEditing-scroll .v-datatable i {
  font-size: 18px;
}
#AttributesElementEditing table.v-table.v-datatable tbody tr td:first-child {
  padding-top: 14px;
}

#AttributesElementEditing table.v-table.v-datatable tbody td.checkbox {
  width: 10px;
  padding: 0px;
}
/* #AttributesElementEditing table.v-table tbody td.checkbox .v-input--checkbox {
} */

#AttributesElementEditing-scroll {
  padding-left: 0px;
  padding-right: 0px;
}
#AttributesElementEditing .v-datatable .v-badge__badge.orange {
  margin-top: 10px;
}
#AttributesElementEditing-scroll .v-datatable td.checkbox > div {
  position: relative;
  top: 5px;
}
#AttributesElementEditing .v-datatable .v-input__slot {
  font-size: 12px !important;
}

#AttributesElementEditing .v-text-field.v-text-field--enclosed .v-input__append-inner {
  margin-top: 2px;
}
#AttributesElementEditing .v-text-field.v-select .v-label {
  top: 4px;
}
#AttributesElementEditing .v-text-field .v-input__icon--clear .v-icon {
  color: red;
}

#btn--parent-pipe {
  margin-left: 0 !important;
  background-color: #2a579a;
}
</style>

<template>
  <Modal
    modalName="AttributesElementEditing"
    title="Edycja atrybutów"
    :module="module"
    @saved="save"
    @opened="opened"
    @cleared="clear"
    :buttons="['save', 'clear']"
  >
    <div id="AttributesElementEditing">
      <v-layout wrap align-center id="main__wrapper">
        <v-container id="AttributesElementEditing-scroll" class="scroll-y" fluid>
          <v-tabs v-model="tabActive" fixed-tabs>
            <v-tab key="attributes" ripple>Atrybuty</v-tab>
            <v-tab
              key="attachments"
              ripple
              v-if="(mode == 'edit-table' && elements.length == 1) || mode == 'edit-single' || (mode == 'edit-attr' && elements.length == 1)"
            >Załączniki</v-tab>
            <v-tab
              key="events"
              ripple
              v-if="(mode == 'edit-table' && elements.length == 1) || mode == 'edit-single' || (mode == 'edit-attr' && elements.length == 1)"
            >Zdarzenia</v-tab>
            <v-tab
              key="watermeters"
              ripple
              v-if="objectTable == 'partitions' && ((mode == 'edit-table' && elements.length == 1) || mode == 'edit-single' || (mode == 'edit-attr' && elements.length == 1))"
            >Wodomierze</v-tab>
            <v-tab 
                key="history" 
                ripple
                v-if="(mode == 'edit-table' && elements.length == 1) || mode == 'edit-single' || (mode == 'edit-attr' && elements.length == 1)"
                >Historia</v-tab>
            
            <v-tab-item key="attributes">
              <v-card flat>
                <v-data-table
                  item-key="__index"
                  v-bind:items="items"
                  class="elevation-1"
                  hide-actions
                  hide-headers
                  v-scroll:#AttributesElementEditing-scroll="onScroll"
                >
                  <template slot="no-data">
                    <v-alert :value="true" color="error" icon="warning">Brak danych do wyświetlenia</v-alert>
                  </template>
                  <template slot="items" slot-scope="props">
                    <tr v-if="!props.item.hide">
                      <td>
                        <v-tooltip bottom :disabled="props.item.value == props.item.value_org">
                          <template slot="activator">
                            <v-badge
                              color="orange"
                              :value="props.item.value != props.item.value_org"
                            >
                              <span slot="badge" class="caption" title="Pole zostało zedytowane">
                                <v-icon dark>edit</v-icon>
                              </span>
                              <span v-text="props.item.display_name"></span>
                              <!-- Głupi, ale działajacy hack -->
                              <span style="visibility:hidden;">a</span>
                            </v-badge>
                          </template>
                          <span
                            v-text="`Oryginalna wartość: '${propsToValue(props, 'value_org')}'`"
                          ></span>
                        </v-tooltip>
                      </td>
                      <template v-if="elements.length > 1">
                        <td class="checkbox">
                          <v-checkbox v-model="props.item.selected" primary hide-details/>
                        </td>
                        <td v-if="props.item.selected && props.item.edited">
                          <VBaseInput
                            v-model="props.item.value"
                            :type="props.item.type"
                            :combo="props.item.combo"
                            :combo-items="props.item.comboItems"
                            :solo="false"
                            :readonly="!edition"
                          />
                        </td>
                        <td v-text="propsToValue(props, 'value')" v-else/>
                      </template>
                      <template v-else>
                        <td v-if="props.item.edited">
                          <VBaseInput
                            v-model="props.item.value"
                            :type="props.item.type"
                            :combo="props.item.combo"
                            :combo-items="props.item.comboItems"
                            :solo="false"
                            :readonly="!edition"
                          />
                        </td>
                        <td v-text="propsToValue(props, 'value')" v-else/>
                      </template>
                    </tr>
                  </template>
                </v-data-table>

                <template v-if="elements.length == 1 && parent_pipe_editor.includes(objectTable)">
                  <br/>
                  <hr
                    style="border-color: red; border-width: 1px; border-style: dotted solid dashed double;"
                  />
                  <br/>
                  <template v-if="objectTable == 'terminals'">
                    <v-layout wrap>
                      <v-flex xs12>
                        <v-input label="Powiązany przewód:">
                          <span
                            style="margin-left: 10px"
                          >{{getFeatureValue('parent_pipe', 'Brak przypisanego przewodu')}}</span>
                        </v-input>
                      </v-flex>
                      <v-flex xs6 v-if="edition">
                        <v-btn
                          dark
                          depressed
                          small
                          id="btn--parent-pipe"
                          v-on:click="selectParentPipe(hasFeatureValue('parent_pipe'))"
                        >{{hasFeatureValue('parent_pipe') ? 'Zmień przewód' : 'Dodaj przewód'}}</v-btn>
                      </v-flex>
                    </v-layout>
                  </template>
                  <template v-else-if="objectTable == 'valves'">
                    <v-layout wrap>
                      <v-flex xs12>
                        <v-input label="Powiązany przewód:">
                          <span
                            style="margin-left: 10px"
                          >{{getFeatureValue('parent_pipe', 'Brak przypisanego przewodu')}}</span>
                        </v-input>
                      </v-flex>
                      <v-flex xs6 v-if="edition">
                        <v-btn
                          dark
                          depressed
                          small
                          id="btn--parent-pipe"
                          v-on:click="selectParentPipe(hasFeatureValue('parent_pipe'))"
                        >{{hasFeatureValue('parent_pipe') ? 'Zmień przewód' : 'Dodaj przewód'}}</v-btn>
                      </v-flex>
                    </v-layout>
                  </template>
                  <template v-else-if="objectTable == 'controls'">
                    <v-layout wrap>
                      <v-flex xs12>
                        <v-input label="Powiązany przewód:">
                          <span
                            style="margin-left: 10px"
                          >{{getFeatureValue('parent_pipe', 'Brak przypisanego przewodu')}}</span>
                        </v-input>
                      </v-flex>
                      <v-flex xs6 v-if="edition">
                        <v-btn
                          dark
                          depressed
                          small
                          id="btn--parent-pipe"
                          v-on:click="selectParentPipe(hasFeatureValue('parent_pipe'))"
                        >{{hasFeatureValue('parent_pipe') ? 'Zmień przewód' : 'Dodaj przewód'}}</v-btn>
                      </v-flex>
                    </v-layout>
                  </template>
                  <template v-else-if="objectTable == 'pumps'">
                    <v-layout wrap>
                      <v-flex xs12>
                        <v-input label="Powiązany przewód:">
                          <span
                            style="margin-left: 10px"
                          >{{getFeatureValue('parent_pipe', 'Brak przypisanego przewodu')}}</span>
                        </v-input>
                      </v-flex>
                      <v-flex xs6 v-if="edition">
                        <v-btn
                          dark
                          depressed
                          small
                          id="btn--parent-pipe"
                          v-on:click="selectParentPipe(hasFeatureValue('parent_pipe'))"
                        >{{hasFeatureValue('parent_pipe') ? 'Zmień przewód' : 'Dodaj przewód'}}</v-btn>
                      </v-flex>
                    </v-layout>
                  </template>
                  <template v-else-if="objectTable == 'partitions'">
                    <v-layout wrap>
                      <v-flex xs12>
                        <v-input label="Powiązany przewód:">
                          <span
                            style="margin-left: 10px"
                          >{{getFeatureValue('parent_pipe', 'Brak przypisanego przewodu')}}</span>
                        </v-input>
                      </v-flex>
                      <v-flex xs6 v-if="edition">
                        <v-btn
                          dark
                          depressed
                          small
                          id="btn--parent-pipe"
                          v-on:click="selectParentPipe(hasFeatureValue('parent_pipe'))"
                        >{{hasFeatureValue('parent_pipe') ? 'Zmień przewód' : 'Dodaj przewód'}}</v-btn>
                      </v-flex>
                    </v-layout>
                  </template>
                  <template v-else-if="objectTable == 'locks'">
                    <v-layout wrap>
                      <v-flex xs12>
                        <v-input label="Powiązany przewód:">
                          <span
                            style="margin-left: 10px"
                          >{{getFeatureValue('parent_pipe', 'Brak przypisanego przewodu')}}</span>
                        </v-input>
                      </v-flex>
                      <v-flex xs6 v-if="edition">
                        <v-btn
                          dark
                          depressed
                          small
                          id="btn--parent-pipe"
                          v-on:click="selectParentPipe(hasFeatureValue('parent_pipe'))"
                        >{{hasFeatureValue('parent_pipe') ? 'Zmień przewód' : 'Dodaj przewód'}}</v-btn>
                      </v-flex>
                    </v-layout>
                  </template>
                  <template v-else-if="objectTable == 'manholes'">
                    <v-layout wrap>
                      <v-flex xs12>
                        <v-input label="Powiązany przewód:">
                          <span
                            style="margin-left: 10px"
                          >{{getFeatureValue('parent_pipe', 'Brak przypisanego przewodu')}}</span>
                        </v-input>
                      </v-flex>
                      <v-flex xs12 v-if="hasFeatureValue('parent_pipe')">
                        <v-input label="Warstwa obiektu nadrzędnego:">
                          <span
                            style="margin-left: 10px"
                          >{{getFeatureValue('parent_pipe_layer', 'Brak przypisanej warstwy')}}</span>
                        </v-input>
                      </v-flex>
                      <v-flex xs6 v-if="edition">
                        <v-btn
                          dark
                          depressed
                          small
                          id="btn--parent-pipe"
                          v-on:click="selectParentPipe(hasFeatureValue('parent_pipe'))"
                        >{{hasFeatureValue('parent_pipe') ? 'Zmień przewód' : 'Dodaj przewód'}}</v-btn>
                      </v-flex>
                    </v-layout>
                  </template>
                  <template v-else-if="objectTable == 'pumping_stations_sewers'">
                    <v-layout wrap>
                      <v-flex xs12>
                        <v-input label="Powiązany przewód:">
                          <span
                            style="margin-left: 10px"
                          >{{getFeatureValue('parent_pipe', 'Brak przypisanego przewodu')}}</span>
                        </v-input>
                      </v-flex>
                      <v-flex xs6 v-if="edition">
                        <v-btn
                          dark
                          depressed
                          small
                          id="btn--parent-pipe"
                          v-on:click="selectParentPipe(hasFeatureValue('parent_pipe'))"
                        >{{hasFeatureValue('parent_pipe') ? 'Zmień przewód' : 'Dodaj przewód'}}</v-btn>
                      </v-flex>
                    </v-layout>
                  </template>
                </template>
              </v-card>
            </v-tab-item>           
            <v-tab-item
              key="attachments"
              v-if="(mode == 'edit-table' && elements.length == 1) || mode == 'edit-single' || (mode == 'edit-attr'  && elements.length == 1)"
            >
              <v-card flat>
                <v-layout row>
                  <v-flex xs12>
                    <v-subheader class="font--primary">Powiązane załączniki</v-subheader>
                    <div
                      v-if="ifAttachments.hasOwnProperty('data') && ifAttachments.data.length > 0"
                    >
                      <li
                        class="list__container--el"
                        v-for="(index, key) in attachmentsArr.data"
                        v-bind:key="key"
                      >
                        <span>{{index.id}} - {{index.filename}}</span>
                        <span>
                          <v-icon
                            v-on:click="downloadAttachment(index.id, index.filename)"
                            small
                            title="Pobierz załącznik"
                          >cloud_download</v-icon>
                          <v-icon
                            v-on:click="deleteAttachment(index.id)"
                            small
                            title="Usuń załącznik"
                          >delete</v-icon>
                        </span>
                      </li>
                    </div>
                    <div v-else>
                      <p class="font--primary">Brak powiązanych załączników</p>
                    </div>
                    <AddAttachment
                      ref="childComponent"
                      v-on:attachmentAdded="updateList"
                      v-on:attachmentDeleted="updateList"
                      v-on:confDialogOpened="triggerDialogAttach"
                      v-bind:id_="featureId"
                      v-bind:objectType="objectType"
                      v-bind:objectTable="objectTable"
                      v-bind:auto="true"
                      :module="module"
                    />
                  </v-flex>
                </v-layout>
              </v-card>
            </v-tab-item>
            <v-tab-item
              key="events"
              v-if="(mode == 'edit-table' && elements.length == 1) || mode == 'edit-single' || (mode == 'edit-attr'  && elements.length == 1)"
            >
              <v-card flat>
                <Events
                  style="margin-top: 15px"
                  v-bind:featureEvents="featureEvents"
                  v-bind:objectType="objectType"
                  v-bind:objectTable="objectTable"
                  v-bind:id="featureId"
                  :module="module"
                />
              </v-card>
            </v-tab-item>
            <v-tab-item
              key="watermeters"
              v-if="objectTable == 'partitions' && ((mode == 'edit-table' && elements.length == 1) || mode == 'edit-single' || (mode == 'edit-attr' && elements.length == 1))"
            >
              <v-card flat>
                <v-expansion-panel focusable v-model="panelIndex">
                  <v-expansion-panel-content
                    v-for="(feature, index) in watermeters"
                    v-bind:key="index"
                  >
                    <div slot="header">
                      Wodomierz:
                      <span v-text="feature.properties.billing_id"></span>
                    </div>

                    <template>
                      <v-btn
                        dark
                        depressed
                        small
                        id="btn--parent-pipe"
                        v-on:click="deleteWatermeter(feature, index)"
                        v-if="edition"
                      >Usuń przypisany wodomierz</v-btn>
                      <v-list>
                        <v-list-tile v-bind:key="feature.id">
                          <v-list-tile-content>
                            <v-list-tile-title>ID</v-list-tile-title>
                            <v-list-tile-sub-title v-text="feature.id"></v-list-tile-sub-title>
                          </v-list-tile-content>
                        </v-list-tile>

                        <v-list-tile
                          v-bind:key="key"
                          v-for="(label, key) in watermeter_labels"
                        >
                          <v-list-tile-content>
                            <v-list-tile-title>{{label}}:</v-list-tile-title>
                            <v-list-tile-sub-title v-text="feature.properties[key]"></v-list-tile-sub-title>
                          </v-list-tile-content>
                        </v-list-tile>
                      </v-list>
                    </template>
                  </v-expansion-panel-content>
                </v-expansion-panel>

                <template v-if="edition">
                  <v-select
                    label="Dostępne wolne wodomierze"
                    :items="avalibleWatermeters"
                    item-text="properties.NrWodomierz"
                    :return-object="true"
                    no-data-text="Brak wolnych wodomierzy"
                    v-model="selectedWatermeter"
                    id="selectStart"
                  ></v-select>
                  <v-btn
                    dark
                    depressed
                    small
                    id="btn--parent-pipe"
                    v-on:click="addWatermeter"
                  >Przypisz wodomierz z listy</v-btn>
                  <v-btn
                    dark
                    depressed
                    small
                    id="btn--parent-pipe"
                    v-on:click="showAddNewWatermeter"
                  >Dodaj i przypisz nowy wodomierz</v-btn>
                </template>
              </v-card>
            </v-tab-item>
            <v-tab-item 
              key="history"
              v-if="(mode == 'edit-table' && elements.length == 1) || mode == 'edit-single' || (mode == 'edit-attr'  && elements.length == 1)"
            >
              <div class="wrapper">
                <SingleObjectHistoryTable :featureId="featureId" :objectTable="objectTable"/>
              </div>
            </v-tab-item>
          </v-tabs>
        </v-container>
      </v-layout>
    </div>
  </Modal>
</template>

<script>
import Modal from "../../../shared/Modal";
import VBaseInput from "../components/VBaseInput";
import AddAttachment from "../../../shared/AddAttachment";
import Events from "../../../shared/Events";
import TreeFeatures from "../../../../utils/TreeFeatures.js";
import SingleObjectHistoryTable from "../../table/history/SingleObjectHistoryTable";

import { Vector as VectorLayer } from "ol/layer";
import {
  buffer as bufferExtent,
  createOrUpdateFromCoordinate
} from "ol/extent";

import OL3Parser from "jsts/org/locationtech/jts/io/OL3Parser";
import {
  Coordinate,
  Geometry as jstsGeometry
} from "jsts/org/locationtech/jts/geom";
import { BufferOp } from "jsts/org/locationtech/jts/operation/buffer";
import { RelateOp } from "jsts/org/locationtech/jts/operation/relate";

const ol_parser = new OL3Parser();

import {
  LineString,
  Polygon,
  MultiPoint,
  MultiPolygon,
  MultiLineString,
  Point
} from "ol/geom";
import LinearRing from "ol/geom/LinearRing";
import GeometryCollection from "ol/geom/GeometryCollection";
ol_parser.inject(
  Point,
  LineString,
  LinearRing,
  Polygon,
  MultiPoint,
  MultiLineString,
  MultiPolygon,
  GeometryCollection
);

//<editor-fold defaultstate="collapsed" desc="config jsts geometry">
jstsGeometry.prototype.buffer = function() {
  return BufferOp.bufferOp(this, ...arguments);
};
jstsGeometry.prototype.intersects = function(g) {
  return RelateOp.intersects(this, g);
};
//</editor-fold>

import chain from "lodash/chain";
import value from "lodash/value";
import mixin from "lodash/mixin";
import _ from "lodash/wrapperLodash";
import map from "lodash/map";
import filter from "lodash/filter";
import includes from "lodash/includes";
import isEmpty from "lodash/isEmpty";
//import some from "lodash/some";
import isArray from "lodash/isArray";
import each from "lodash/each";
import uniq from "lodash/uniq";
import clone from "lodash/clone";
import keyBy from "lodash/keyBy";
import mapValues from "lodash/mapValues";
import get from "lodash/get";
mixin(_, {
  get: get,
  map,
  filter,
  includes,
  isEmpty,
  //some,
  isArray,
  uniq,
  each,
  chain,
  clone,
  keyBy,
  mapValues
});
_.value = value;
_.prototype.value = value;

//templates
import templateModalDynamicBase from "../../../shared/templateModalDynamicBase.html";
import templateDialogAddWatermeters from "../template/templateDialogAddWatermeters.html";

const tolernace = 0.5;

export default {
  components: {
    Modal,
    VBaseInput,
    Events,
    AddAttachment,
    SingleObjectHistoryTable
  },
  data: () => ({
    offsetTop: 0,
    items: [],
    module:"addAttachmentsToObjects",

    tabActive: null,

    mode: "edit-table",
    featureId: false,
    objectType: "layers",
    objectTable: "",
    attachmentsArr: [],

    panelIndex: -1,
    updateWatermeters: 0,
    updateAvalibleWatermeters: 0,
    selectedWatermeter: false
  }),
  computed: {
    edition() {
      return this.$store.getters.getEditionOn;
    },
    activeModals() {
      return this.$store.getters.getModalsList;
    },

    map() {
      return this.$store.getters.getMap;
    },
    layers() {
      const self = this;
      const wodkan_layers = _.chain(
        self.map
          .getLayers()
          .item(2) //warstwy wodkan
          .getLayers()
          .getArray()
      )
        .filter(layer =>
          _.includes(["water", "sewer"], layer.get("layer_type"))
        )
        .map(layer => ({
          name: layer.get("full_name"),
          key: layer.get("full_type"),
          type: "wodkan",
          instance: self.$root.createProxy(layer)
        }))
        .value();

      const user_layers = _.chain(
        self.map
          .getLayers()
          .item(1) //warstwy różne
          .getLayers()
          .item(0) //warstwy użtkownika
          .getLayers()
          .getArray()
      )
        .filter(layer => layer instanceof VectorLayer)
        .map(layer => ({
          name: `WU: ${layer.get("name")}`,
          key: layer.get("full_type"),
          type: "user",
          instance: self.$root.createProxy(layer)
        }))
        .value();

      return _.keyBy([...wodkan_layers, ...user_layers], "key");
    },
    socket() {
      return this.$store.getters.getSocket;
    },

    ifAttachments() {
      return this.$store.getters.getObjectAttachments;
    },
    featureEvents() {
      return this.$store.getters.getFeatureEvents;
    },
    
    layerWaterWatermeters() {
      return _.find(this.$store.getters.getLayersWater, (l) => l.type === "watermeters");
    },
  },
  asyncComputed: {
    watermeters: {
      get() {
        if (this.elements.length !== 1) {
          return Promise.resolve([]);
        }
        if (!this.socket) {
          return fetch(
            `${this.$store.getters.getApiURL}/features/watermeters?token=${
              this.$store.getters.getToken
            }&filter=parent_partition=${this.elements[0].getId()}`
          )
            .then(r => r.json())
            .then(data => data.features)
            .catch(() => []);
        }
        return new Promise((resolve, reject) => {
          this.socket.emit(
            "features",
            {
              layer: "watermeters",
              filter: {
                filter: `parent_partition=${this.elements[0].getId()}`
              }
            },
            data => {
              resolve(data.features);
            }
          );
        });
      },
      default: () => [],
      watch: ["updateWatermeters"],
      lazy: true
    },
    avalibleWatermeters: {
      get() {
        return fetch(
          `${this.$store.getters.getApiURL}/features/watermeters?token=${
            this.$store.getters.getToken
          }&filter=parent_partition=NULL`
        )
          .then(r => r.json())
          .then(data => {
            return _.map(data.features, feature => {
              feature.properties.NrWodomierz = `${feature.get('billing_id')}`;
              return feature;
            });
          })
          .catch(() => []);
      },
      default: () => [],
      watch: ["updateAvalibleWatermeters"],
      lazy: true
    }
  },
  watch: {
    tabActive(_new) {
      if (_new === 3) {
        //wodomierze
        this.updateWatermeters++;
      }
    },
    edition(_new) {
      this.disbaleButton(_new);
    }
  },
  created() {
    this.elements = [];
    this.$root.$on(
      "editAttributesElements",
      (elements, fields, full_type, mode = "edit-table") => {
        this.mode = mode;

        this.elements = elements;
        this.fields = fields;
        this.items = this.generateItems();
        this.objectTable = full_type.split('@')[0];
        this.full_type = full_type;

        if (this.elements.length === 1) {
          this.featureId = elements[0].getId(); //edycja pojedyńczego
        } else {
          this.featureId = false; //edycja masowa
        }

        if (full_type === "partitions") {
          this.updateAvalibleWatermeters++;
        }

        this.show("AttributesElementEditing");
        this.updateList();
      }
    );

    this.watermeter_labels_init = false;
    this.watermeter_labels = {};
    this.parent_pipe_editor = ['terminals', 'valves', 'controls', 'pumps', 'partitions', 'locks', 'manholes', 'pumping_stations_sewers'];
  },
  methods: {
    show(title) {
      if (this.activeModals.indexOf(title) === -1) {
        this.$store.commit("addModal", title);
        this.$modal.show(title);
      }
    },
    opened() {
      this.offsetTop = 0;
      
      this.initWatermeterLabels();
      this.disbaleButton(this.edition);
    },
    clear() {
      this.items = this.generateItems();
    },
    save() {
      if (!this.edition) {
        this.$root.$emit("showSnackbar", "error", "Edycja jest rozłączona");
        return;
      }

      let items = [];
      if (this.elements.length === 1) {
        items = _.filter(this.items, v => v.edited && v.value !== v.value_org);
      } else {
        items = _.filter(this.items, v => v.edited && v.selected);
      }

      const properties = _(items)
        .map(v => {
          const key = v.name;
          let value = v.value;

          if (v.type === "string") {
            //text
            if (value === "NULL") {
              value = null;
            }
          } else if (v.type === "datetime" || v.type === "date") {
            //date
            value = value == "" ? null : value;
          } else if (v.type === "time") {
            //date
            value = value == "" ? null : value;
          } else if (v.type === "integer" || v.type === "real") {
            //number
            value = value == "" ? null : value;
          }

          return {
            key,
            value
          };
        })
        .keyBy("key")
        .mapValues("value")
        .value();

      let ids = false;
      if (this.mode === "edit-table" || this.mode === "edit-attr") {
        ids = _.map(this.elements, f => f.getId());
      }

      if (!_.isEmpty(properties)) {
        this.$root.$emit("saveServerFeatures", {
          type: this.mode === "add-single" ? "add" : "attributes",
          ids,
          properties
        });
        this.$modal.hide("AttributesElementEditing");
      } else if (this.mode === "add-single") {
        this.$root.$emit("showSnackbar", "error", "Nie podano żadnych danych");
      } else if (this.mode === "draw-single") {
        this.$root.$emit(
          "showSnackbar",
          "success",
          "Wysłano z domyślnymi atrybutami"
        );
      } else {
        this.$root.$emit(
          "showSnackbar",
          "orange",
          "Nic nie zostało zmiennione"
        );
      }
    },

    generateItems() {
      const items = [];

      if (this.elements.length === 1) {
        const feature = this.elements[0];
        items.push(this.generateItem("id", feature));
        _.each(this.fields, field => {
          const item = this.generateItem(field, feature);
          if (
            field.name === "parent_pipe" ||
            field.name === "parent_pipe_layer"
          ) {
            item.hide = true;
          }
          if (
            this.mode === "add-single" &&
            "read_only" in field &&
            field.read_only
          ) {
            item.hide = true;
          }
          items.push(item);
        });
      } else {
        _.each(this.fields, field => {
          const item = this.generateItem(field, this.elements);
          if (
            field.name === "parent_pipe" ||
            field.name === "parent_pipe_layer"
          ) {
            item.hide = true;
          }
          if (
            this.mode === "add-single" &&
            "read_only" in field &&
            field.read_only
          ) {
            item.hide = true;
          }
          items.push(item);
        });
      }

      return items;
    },
    generateItem(field, features) {
      if (field === "id") {
        return {
          selected: false,
          edited: false,
          display_name: "Id",
          value: features.getId(),
          value_org: features.getId(),
          type: false,
          combo: false,
          hide: this.mode === "add-single" || this.mode === "draw-single",
          comboItems: []
        };
      } else {
        const item = {
          selected: false,
          edited: true,
          display_name: field.display_name,
          name: field.name,
          type: field.data_type,
          combo: false,
          hide: false,
          comboItems: []
        };
        if ("read_only" in field && field.read_only) {
          item.edited = false;
        }

        if (_.isArray(features)) {
          const value = _(features)
            .map(feature => feature.get(field.name) || "")
            .uniq()
            .value();

          if ("dictionary" in field) {
            item.value =
              value.length === 1 ? features[0].get(field.name) || "" : "";
            item.dictionary = _.clone(field.dictionary);
            item.combo = true;
            item.comboItems = _.map(field.dictionary, (v, key) => ({
              key,
              value: v.value
            }));
          } else {
            item.value = value.length === 1 ? value[0] : "";
          }
        } else {
          if ("dictionary" in field) {
            item.value = features.get(field.name) || "";
            item.dictionary = _.clone(field.dictionary);
            item.combo = true;
            item.comboItems = _.map(field.dictionary, (v, key) => ({
              key,
              value: v.value
            }));
          } else {
            item.value = features.get(field.name) || "";
          }
        }

        item.value_org = item.value;
        return item;
      }
    },

    propsToValue(props, key) {
      return props.item.combo
        ? (props.item.dictionary[props.item[key]] || {}).value || ""
        : props.item[key];
    },

    getFeatureValue(key, _default = "") {
      let item = _.find(this.items, item => item.name === key);
      if (item !== undefined && item.value !== '') {
        item = item.value;
      } else {
        item = null;
      }
      return item === null ? _default : item;
    },
    hasFeatureValue(key) {
      let item = _.find(this.items, item => item.name === key);
      if (item !== undefined && item.value !== '') {
        item = item.value;
      } else {
        item = null;
      }
      return item !== null;
    },
    setFeatureValue(key, value) {
      let item = _.find(this.items, item => item.name === key);
      if (item !== undefined) {
        item.value = value;
      }
    },

    selectParentPipe(_new) {
      const self = this;
      
      self.$root.$emit(
        "showSnackbar",
        "blue",
        "Kliknij na mapie, aby wskazać obiekt"
      );
      self.map.getViewport().style.cursor = "crosshair";

      let layers;
      switch (self.objectTable) {
        case "terminals":
        case "valves":
        case "controls":
        case "pumps":
          layers = ["pipes"];
          break;
        case "partitions":
        case "locks":
          layers = ["terminals"];
          break;
        case "manholes":
          layers = ["pipes", "terminals"];
          break;
        case "pumping_stations_sewers":
          layers = ["pipes_sewers"];
          break;
      }

      self.$root.$once("selectionElementCallback", featuresLayers => {
        //console.log(featuresLayers);
        self.map.getViewport().style.cursor = "";
        
        let featuresPipes = _.get(featuresLayers, "pipes.features", []);
        let featuresTerminals = _.get(featuresLayers, "terminals.features", []);
        let featuresPipesSewers = _.get(featuresLayers, "pipes_sewers.features", []);
        if (featuresPipes.length === 0 && featuresTerminals.length === 0 && featuresPipesSewers.length === 0) {
          self.$root.$emit(
            "showSnackbar",
            "orange",
            "Nic nie zostało zaznaczonę"
          );
          return;
        }

        switch (self.objectTable) {
          case "terminals": {
            const features = _.filter(featuresPipes, feature =>
              self.verifyPossibility(feature)
            );

            if (features.length === 0) {
              self.$root.$emit(
                "showSnackbar",
                "red",
                "Nie można powiązać tego przewodu"
              );
            } else if (
              features[0].getId() === self.getFeatureValue("parent_pipe")
            ) {
              self.$root.$emit(
                "showSnackbar",
                "orange",
                "Nic się nie zmieniło"
              );
            } else {
              self.setFeatureValue("parent_pipe", features[0].getId());
            }
            break;
          }
          case "valves": {
            const features = _.filter(featuresPipes, feature =>
              self.verifyPossibility(feature)
            );

            if (features.length == 0) {
              self.$root.$emit(
                "showSnackbar",
                "red",
                "Nie można powiązać tego przewodu"
              );
            } else if (
              features[0].getId() === self.getFeatureValue("parent_pipe")
            ) {
              self.$root.$emit(
                "showSnackbar",
                "orange",
                "Nic się nie zmieniło"
              );
            } else {
              self.setFeatureValue("parent_pipe", features[0].getId());
            }
            break;
          }
          case "controls": {
            const features = _.filter(featuresPipes, feature =>
              self.verifyPossibility(feature)
            );

            if (features.length == 0) {
              self.$root.$emit(
                "showSnackbar",
                "red",
                "Nie można powiązać tego przewodu"
              );
            } else if (
              features[0].getId() === self.getFeatureValue("parent_pipe")
            ) {
              self.$root.$emit(
                "showSnackbar",
                "orange",
                "Nic się nie zmieniło"
              );
            } else {
              self.setFeatureValue("parent_pipe", features[0].getId());
            }
            break;
          }
          case "pumps": {
            const features = _.filter(featuresPipes, feature =>
              self.verifyPossibility(feature)
            );

            if (features.length === 0) {
              self.$root.$emit(
                "showSnackbar",
                "red",
                "Nie można powiązać tego przewodu"
              );
            } else if (
              features[0].getId() === self.getFeatureValue("parent_pipe")
            ) {
              self.$root.$emit(
                "showSnackbar",
                "orange",
                "Nic się nie zmieniło"
              );
            } else {
              self.setFeatureValue("parent_pipe", features[0].getId());
            }
            break;
          }
          case "partitions": {
            const features = _.filter(featuresTerminals, feature =>
              self.verifyPossibility(feature)
            );

            if (features.length == 0) {
              self.$root.$emit(
                "showSnackbar",
                "red",
                "Nie można powiązać tego przewodu"
              );
            } else if (
              features[0].getId() === self.getFeatureValue("parent_pipe")
            ) {
              self.$root.$emit(
                "showSnackbar",
                "orange",
                "Nic się nie zmieniło"
              );
            } else {
              self.setFeatureValue("parent_pipe", features[0].getId());
            }
            break;
          }
          case "locks": {
            const features = _.filter(featuresTerminals, feature =>
              self.verifyPossibility(feature)
            );

            if (features.length == 0) {
              self.$root.$emit(
                "showSnackbar",
                "red",
                "Nie można powiązać tego przewodu"
              );
            } else if (
              features[0].getId() === self.getFeatureValue("parent_pipe")
            ) {
              self.$root.$emit(
                "showSnackbar",
                "orange",
                "Nic się nie zmieniło"
              );
            } else {
              self.setFeatureValue("parent_pipe", features[0].getId());
            }
            break;
          }
          case "manholes": {
            if (featuresPipes.length > 0) {
              const features = _.filter(featuresPipes, feature =>
                self.verifyPossibility(feature, "pipe")
              );

              if (features.length == 0) {
                self.$root.$emit(
                  "showSnackbar",
                  "red",
                  "Nie można powiązać tego przewodu"
                );
              } else if (
                features[0].getId() === self.getFeatureValue("parent_pipe") &&
                self.getFeatureValue("parent_pipe_layer") === "pipes"
              ) {
                self.$root.$emit(
                  "showSnackbar",
                  "orange",
                  "Nic się nie zmieniło"
                );
              } else {
                self.setFeatureValue("parent_pipe", features[0].getId());
                self.setFeatureValue("parent_pipe_layer", "pipes");
              }
            } else if (featuresTerminals.length > 0) {
              const features = _.filter(featuresTerminals, feature =>
                self.verifyPossibility(feature, "terminal")
              );

              if (features.length == 0) {
                self.$root.$emit(
                  "showSnackbar",
                  "red",
                  "Nie można powiązać tego przewodu"
                );
              } else if (
                features[0].getId() === self.getFeatureValue("parent_pipe") &&
                self.getFeatureValue("parent_pipe_layer") === "terminals"
              ) {
                self.$root.$emit(
                  "showSnackbar",
                  "orange",
                  "Nic się nie zmieniło"
                );
              } else {
                self.setFeatureValue("parent_pipe", features[0].getId());
                self.setFeatureValue("parent_pipe_layer", "pipes");
              }
            }

            break;
          }
          case "pumping_stations_sewers": {
            const features = _.filter(featuresPipesSewers, feature => self.verifyPossibility(feature));

            if (features.length === 0) {
              self.$root.$emit(
                "showSnackbar",
                "red",
                "Nie można powiązać tego przewodu"
              );
            } else if (
              features[0].getId() === self.getFeatureValue("parent_pipe")
            ) {
              self.$root.$emit(
                "showSnackbar",
                "orange",
                "Nic się nie zmieniło"
              );
            } else {
              self.setFeatureValue("parent_pipe", features[0].getId());
            }
            break;
          }
        }
      });

      self.$root.$emit("enableSelectionElement", {
        layers: layers,
        selected: false,
        ignoreDivision: true //ignorowanie sztucznego podziału przy warstwach kanalizacyjnych
      });
    },
    getClosestFeatures(source, coord, ignored = []) {
      let features = source.getFeaturesInExtent(
        bufferExtent(createOrUpdateFromCoordinate(coord), tolernace)
      );
      return _.filter(
        features,
        f => ignored.length === 0 || !_.includes(ignored, f.getId())
      );
    },
    getTreeFeatures(source, feature) {
      const self = this;

      let coords = feature.getGeometry().getCoordinates();
      const tree = new TreeFeatures.Tree();

      let edge = tree.getOrCreateEdge(coords[0], coords[coords.length - 1]);
      edge.data = {
        feature,
        geometry: ol_parser.read(feature.getGeometry())
      };

      while (true) {
        let change = false;

        _.each(tree.vertices.slice(), vertex => {
          if (vertex.visited) {
            return;
          } else {
            vertex.visited = true;
          }
          change = true;

          const features = self.getClosestFeatures(source, [
            vertex.coordinate.x,
            vertex.coordinate.y
          ]);
          _.each(features, feature => {
            coords = feature.getGeometry().getCoordinates();
            edge = tree.getOrCreateEdge(coords[0], coords[coords.length - 1]);
            if (!edge.data) {
              edge.data = {
                feature,
                geometry: ol_parser.read(feature.getGeometry())
              };
            }
          });
        });

        if (!change) {
          break;
        }
      }

      _.each(tree.vertices, vertex => {
        vertex.visited = false;
      });

      //console.log(tree);
      return tree;
    },
    verifyPossibility(feature, mode) {
      const self = this;
      const base = this.elements[0];
      const geometryBase = ol_parser.read(base.getGeometry());
      const geometry = ol_parser.read(feature.getGeometry());
      const bufor = 0.1;

      function action(edge, compare) {
        //przejście po drzewie aby znaleść powiązany przewód
        const results = [];
        _.each(edge.getNextEdges(), edges => {
          _.each(edges, edge2 => {
            if (edge2.visited) {
              return;
            } else {
              edge2.visited = true;
            }
            if (compare(edge2.data)) {
              results.push(edge2);
              results.push(...action(edge2, compare));
            }
          });
        });
        return results;
      }

      switch (self.objectTable) {
        case "terminals": {
          if (geometryBase.buffer(bufor).intersects(geometry.buffer(bufor))) {
            return true;
          } else {
            const tree = self.getTreeFeatures(
              self.layers["terminals"].instance.getSource(),
              base
            );
            return (
              action(
                tree.findEdge(
                  edge => edge.data.feature.getId() === base.getId()
                ),
                data =>
                  geometry.buffer(bufor).intersects(data.geometry.buffer(bufor))
              ) !== 0
            );
          }
          break;
        }
        case "valves": {
          if (geometryBase.buffer(bufor).intersects(geometry.buffer(bufor))) {
            const startPoint = geometry.getStartPoint();
            const endPoint = geometry.getEndPoint();

            return geometryBase.buffer(bufor).intersects(startPoint.buffer(bufor))
              || geometryBase.buffer(bufor).intersects(endPoint.buffer(bufor));
          } else {
            return false;
          }
          break;
        }
        case "controls": {
          if (geometryBase.buffer(bufor).intersects(geometry.buffer(bufor))) {
            return true;
          } else {
            return false;
          }
          break;
        }
        case "pumps": {
          if (geometryBase.buffer(bufor).intersects(geometry.buffer(bufor))) {
            return true;
          } else {
            return false;
          }
          break;
        }
        case "partitions": {
          if (geometryBase.buffer(bufor).intersects(geometry.buffer(bufor))) {
            return true;
          } else {
            return false;
          }
          break;
        }
        case "locks": {
          if (geometryBase.buffer(bufor).intersects(geometry.buffer(bufor))) {
            return true;
          } else {
            return false;
          }
          break;
        }
        case "manholes": {
          if (geometryBase.buffer(bufor).intersects(geometry.buffer(bufor))) {
            return true;
          } else {
            return false;
          }
          break;
        }
        case "pumping_stations_sewers": {
          if (geometryBase.buffer(bufor).intersects(geometry.buffer(bufor))) {
            return true;
          } else {
            return false;
          }
          break;
        }
      }
    },

    onScroll(e) {
      this.offsetTop = e.target.scrollTop;
    },

    downloadAttachment(attachmentId, attachmentName) {
      this.$refs.childComponent.downloadAttachment(
        attachmentId,
        attachmentName
      );
    },
    deleteAttachment(attachmentId) {
      this.$refs.childComponent.deleteAttachment(attachmentId);
    },

    updateList() {
      if (this.featureId) {
        let payload = {
          object_type: this.objectType,
          object_table: this.objectTable,
          oid: this.featureId
        };
        this.$store
          .dispatch("getAttachmentsForObject", payload)
          .then(success => {
            if (success) {
              this.attachmentsArr = this.$store.getters.getObjectAttachments;
            }
          });
      }
    },
    triggerDialogAttach(val) {
      this.$emit("confDialogOpened", val);
    },

    addWatermeter() {
      if (!this.selectedWatermeter) {
        this.$root.$emit(
          "showSnackbar",
          "error",
          "Żaden wodomierz nie został wybrany"
        );
        return;
      }

      this.$root.$emit("saveServerFeatures", {
        type: "attributes",
        layer: "watermeters",
        ids: [this.selectedWatermeter.id],
        properties: {
          parent_partition: `${this.elements[0].getId()}`
        }
      });

      this.selectedWatermeter = false;
      this.updateAvalibleWatermeters++;
    },
    showAddNewWatermeter() {
      /*this.$root.$emit("saveServerFeatures", {
        type: "attributes",
        layer: "watermeters",
        ids: [this.selectedWatermeter.id],
        properties: {
          parent_partition: `${this.elements[0].getId()}`
        }
      });*/

      const self = this;

      let nameModal;
      const template = _.template(templateModalDynamicBase, {
        interpolate: /%%([\s\S]+?)%%/g
      })({
        content: templateDialogAddWatermeters
      });
      self.watermeterBillingId = "";

      const execut = (billing_id, parent_partition) => {
        billing_id = billing_id.trim();
        if (billing_id === "") {
          self.$root.$emit("showSnackbar", "red", "Nie podano żadnego ID");
          return;
        }

        self.$root.$emit("saveServerFeatures", {
          type: 'add',
          layer: 'watermeters',
          ids : false,
          properties : {
            billing_id,
            parent_partition
          }
        });
        
        self.selectedWatermeter = false;
        self.updateAvalibleWatermeters++;
      };

      self.$modal.show(
        {
          template,
          props: ["title", "buttons"],
          data: () => ({
            watermeterBillingId: self.watermeterBillingId
          }),
          methods: {
            updateValue(name, value) {
              if (name in self) {
                self[name] = value;
              }
            }
          }
        },
        {
          title: "Dodaj nowy wodomierz i przypisz",
          buttons: [
            {
              title: "ANULUJ",
              handler(event) {
                self.$modal.hide(nameModal);
              }
            },
            {
              title: "WYKONAJ",
              handler(event) {
                self.$modal.hide(nameModal);
                self.$root.$emit(
                  "showSnackbar",
                  "#2a579a",
                  "Zapisywanie proszę czekać"
                );
                setTimeout(() => execut(self.watermeterBillingId, self.elements[0].getId()), 500);
              }
            }
          ]
        },
        {
          height: "auto",
          "click-to-close": false,
          classes: ["v--modal", "vue-dialog"]
        },
        {
          "before-open"(event) {
            nameModal = event.name;
          },
          "before-close"(event) {
          }
        }
      );
    },
    deleteWatermeter(watermeter, index) {
      this.$root.$emit("saveServerFeatures", {
        type: "attributes",
        layer: "watermeters",
        ids: [watermeter.id],
        properties: {
          parent_partition: null
        }
      });
      this.selectedWatermeter = false;
      this.updateAvalibleWatermeters++;
    },
    
    initWatermeterLabels() {
      if (this.layerWaterWatermeters && !this.watermeter_labels_init) {
        this.watermeter_labels_init = true;
        _.each((this.layerWaterWatermeters || {fields : []}).fields, (field) => {
          if ('parent_partition' === field.name) {
            return;
          }
          this.watermeter_labels[field.name] = field.display_name;
        });
        this.$forceUpdate();
      }
    },
    
    disbaleButton(value) {
      const q = '#AttributesElementEditing .buttons__right .group.pa-2';
      if (value) {
        document.querySelectorAll(q).forEach((e) => e.classList.remove("v-btn--disabled"));
      } else {
        document.querySelectorAll(q).forEach((e) => e.classList.add("v-btn--disabled"));
      }
    }
  },
  mounted() {
    this.$root.$on("deletedAttachmentGlobal", this.updateList);
    this.initWatermeterLabels();
  }
};
</script>



// WEBPACK FOOTER //
// src/components/viewer/edition/modals/AttributesElementEditing.vue